export const FR = {
  meta: {
    title: "Zorem Commodities — Contreparties vérifiées",
    description: "Zorem Commodities LLC : négoce de métaux précieux et minerais critiques — or doré, lingots LBMA, cathodes de cuivre 99,99 % — corridors vérifiés Afrique de l'Est et de l'Ouest, conformité FATF, exécution disciplinée.",
  },
  hero: {
    eyebrow: "Facilitateur, pas courtier · Phoenix, Arizona",
    lines: ["Approvisionnement réel.", "Contreparties vérifiées.", "Exécution disciplinée."],
    sub: "Relier les ressources naturelles du monde à l'industrie mondiale par la confiance, la conformité et une exécution disciplinée. Transactions structurées uniquement. Aucun canal informel.",
    ctaPrimary: "Soumettre un mandat",
    ctaSecondary: "Explorer les matières premières",
  },
  stats: [
    { value: "FATF", label: "Conformité alignée", sub: "Réseau filtré OFAC · UE · ONU · UK HMT" },
    { value: "3", label: "Corridors d'exécution", sub: "Afrique de l'Est et centrale · Afrique de l'Ouest · Golfe" },
    { value: "12+", label: "Matières vérifiées", sub: "Métaux précieux et minerais industriels" },
    { value: "100 %", label: "KYC/AML des contreparties", sub: "Aucun mandataire non vérifié n'avance" },
  ],
  axes: {
    eyebrow: "Axes d'activité principaux",
    title: "Dans ce métier, beaucoup parlent. Nous exécutons.",
    paras: [
      "Zorem Commodities s'adresse à l'opérateur qui a déjà payé le prix d'une chaîne rompue — un envoi retardé, une lettre de crédit fragile, une contrepartie solide sur le papier qui disparaît au moment des documents. Nous existons pour supprimer ces frictions : nous structurons l'opération, vérifions chaque maillon, et restons jusqu'à la livraison de la matière et au mouvement des fonds.",
      "Nos relations sont opérationnelles, pas décoratives. Nous travaillons avec des producteurs qui expédient, des raffineurs qui analysent, des partenaires logistiques qui livrent, et des acheteurs qui paient. Chaque mandat accepté et chaque contrepartie présentée a déjà passé notre diligence raisonnable.",
    ],
  },
  portfolio: {
    eyebrow: "Solutions commerciales & portefeuille",
    title: "Une offre vérifiée, en deux groupes complémentaires.",
    intro: "Chaque ligne s'appuie sur des mandats vendeurs actifs, des offres documentées, des instruments de paiement transférables et des parcours essai-contrat définis.",
    groups: [
      { name: "Groupe I — Métaux précieux & ressources stratégiques", items: ["Or doré — Au 95,89 % · 23,01 carats · vérifié XRF", "Lingots d'or — 99,5 %+ · standard LBMA · 999,9", "Cathodes de cuivre — 99,99 % · LME Grade A · Copperbelt", "Antimoine · Tungstène · Titane · Niobium"] },
      { name: "Groupe II — Minerais industriels & critiques", items: ["Lithium 11 % · Cobalt 28–35 % · Coltan 34/38/45 %", "Cassitérite 60–75 % · Manganèse 35–40 %", "Aluminium A7 — 99,7 % · chargement Tanzanie", "Silice & Zinc · qualité spéciale"] },
    ],
  },
  compliance: {
    eyebrow: "Risques, conformité & protection client",
    title: "Chaque affirmation est provisoire jusqu'à vérification.",
    paras: [
      "Dans le négoce de minerais et d'énergie, le coût d'une contrepartie faible se mesure en millions — et en réputation qui ne se récupère pas. Nous posons les questions qui percent la présentation : qui contrôle réellement la matière ? Qui a la relation bancaire capable d'émettre ou de confirmer l'instrument ? Qui a déjà livré un volume similaire ? Les documents et l'historique de performance décident — pas le marketing.",
    ],
    badges: ["Conforme FATF", "OECD DDG", "KYC / AML vérifié", "Sanctions OFAC · UE · ONU · UK HMT", "Dodd-Frank §1502", "Chaîne de traçabilité"],
  },
  pathway: {
    eyebrow: "Onboarding client & diligence raisonnable",
    title: "Le parcours — six étapes, toutes documentées.",
    steps: ["Découverte — conversation confidentielle", "Fiche d'information client", "Vérification de capacité / fonds", "Diligence raisonnable — KYC, AML, origine, sanctions", "Structure & contrat écrit", "Exécution — essai, puis programme"],
  },
  settlement: {
    eyebrow: "Cadre de règlement & paiement",
    title: "Le règlement est le centre de la structure, pas une réflexion après coup.",
    items: [
      { k: "SBLC / DLC", v: "Sécurité bancaire sur laquelle les deux parties peuvent s'appuyer lorsque la performance est requise." },
      { k: "MT103 / Virement confirmé", v: "Mouvement de fonds direct et traçable selon instructions écrites." },
      { k: "Proof of Funds", v: "Capacité vérifiée avant engagement — pas de lettres circulaires." },
    ],
  },
  leadership: {
    eyebrow: "Direction",
    name: "Bruno Pouliot",
    role: "Fondateur & Principal, Zorem Commodities LLC · Arizona, États-Unis",
    text: "Les mêmes interlocuteurs que vous avez au premier appel restent responsables de la transaction jusqu'à sa clôture. Pas de transfert vers une boîte noire — la responsabilité reste attachée à la relation principale, du mandat jusqu'au règlement.",
  },
  cta: {
    title: "Parlons-en.",
    text: "Si vous avez besoin d'un partenaire qui structure l'opération, vérifie les contreparties, appuie les instruments et reste sur l'exécution jusqu'à la livraison de la matière et au règlement des fonds — alors parlons-en.",
    button: "Soumettre un mandat",
    address: "300 W. Clarendon Ave, Suite 325, Phoenix, AZ 85013 · b@zoremcommodities.com · +1 438 886 1245",
  },
};
